const cardIcon = (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.1829 1.53659H2.81707C2.10988 1.53659 1.53659 2.10988 1.53659 2.81707V18.1829C1.53659 18.8901 2.10988 19.4634 2.81707 19.4634H18.1829C18.8901 19.4634 19.4634 18.8901 19.4634 18.1829V2.81707C19.4634 2.10988 18.8901 1.53659 18.1829 1.53659ZM2.81707 0C1.26125 0 0 1.26125 0 2.81707V18.1829C0 19.7388 1.26125 21 2.81707 21H18.1829C19.7388 21 21 19.7388 21 18.1829V2.81707C21 1.26125 19.7388 0 18.1829 0H2.81707Z"
      fill="#6B00DF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.1098 5.63415H5.89024C5.74881 5.63415 5.63415 5.74881 5.63415 5.89024V7.93902C5.63415 8.08046 5.74881 8.19512 5.89024 8.19512H15.1098C15.2512 8.19512 15.3659 8.08046 15.3659 7.93902V5.89024C15.3659 5.7488 15.2512 5.63415 15.1098 5.63415ZM5.89024 4.09756C4.90017 4.09756 4.09756 4.90017 4.09756 5.89024V7.93902C4.09756 8.9291 4.90017 9.73171 5.89024 9.73171H15.1098C16.0998 9.73171 16.9024 8.9291 16.9024 7.93902V5.89024C16.9024 4.90017 16.0998 4.09756 15.1098 4.09756H5.89024Z"
      fill="#6B00DF"
    />
    <path
      d="M4.09756 12.6768C4.09756 12.1818 4.49887 11.7805 4.9939 11.7805H16.0061C16.5011 11.7805 16.9024 12.1818 16.9024 12.6768C16.9024 13.1719 16.5011 13.5732 16.0061 13.5732H4.9939C4.49887 13.5732 4.09756 13.1719 4.09756 12.6768Z"
      fill="#6B00DF"
    />
    <path
      d="M4.09756 16.2622C4.09756 15.7672 4.49887 15.3659 4.9939 15.3659H16.0061C16.5011 15.3659 16.9024 15.7672 16.9024 16.2622C16.9024 16.7572 16.5011 17.1585 16.0061 17.1585H4.9939C4.49887 17.1585 4.09756 16.7572 4.09756 16.2622Z"
      fill="#6B00DF"
    />
  </svg>
);

const defaultVariantIcon = (
  <svg
    width="500"
    height="500"
    viewBox="0 0 500 500"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="500" height="500" fill="white" />
    <rect
      x="8.5"
      y="7.5"
      width="484"
      height="484"
      rx="25.5"
      fill="white"
      stroke="#6B00DF"
      strokeWidth="15"
    />
    <rect x="68" y="398" width="185" height="47" rx="20" fill="#6B00DF" />
    <path
      d="M219.287 136.35V164.665H103.779V148.731L117.98 133.988C118.989 132.942 120.593 132.942 121.601 133.988L136.328 149.276L137.68 150.68L139.033 149.276L183.576 103.038C184.584 101.992 186.188 101.992 187.196 103.038L219.287 136.35ZM84.0115 57H239.055C247.832 57 255.066 64.4064 255.066 73.6921V185.114C255.066 194.399 247.832 201.805 239.055 201.805H84.0115C75.2339 201.805 68 194.399 68 185.114V73.6921C68 64.4064 75.2339 57 84.0115 57ZM86.2477 186.992H236.818C237.933 186.992 238.987 186.532 239.753 185.736C240.516 184.945 240.933 183.883 240.933 182.792V76.0134C240.933 74.9218 240.516 73.8614 239.753 73.069C238.987 72.2742 237.933 71.814 236.818 71.814H86.2477C85.1334 71.814 84.0796 72.2742 83.3139 73.069C82.5504 73.8614 82.1334 74.9218 82.1334 76.0134V182.792C82.1334 183.883 82.5504 184.945 83.3139 185.736C84.0796 186.532 85.1334 186.992 86.2477 186.992ZM100.798 104.643C100.798 97.0664 106.697 91.0454 113.828 91.0454C120.958 91.0454 126.857 97.0664 126.857 104.643C126.857 112.218 120.958 118.239 113.828 118.239C106.697 118.239 100.798 112.218 100.798 104.643Z"
      fill="#7A00FF"
    />
    <rect
      x="68"
      y="228.848"
      width="364.355"
      height="20"
      rx="10"
      fill="#6B00DF"
    />
    <rect
      x="68"
      y="269.227"
      width="244.155"
      height="20"
      rx="10"
      fill="#6B00DF"
    />
    <rect
      x="68"
      y="320.875"
      width="364.355"
      height="15"
      rx="7.5"
      fill="#6B00DF"
    />
    <rect
      x="68"
      y="349.986"
      width="329.609"
      height="15"
      rx="7.5"
      fill="#6B00DF"
    />
  </svg>
);

const cardWithWrappersVariantIcon = (
  <svg
    width="500"
    height="500"
    viewBox="0 0 500 500"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="500" height="500" fill="white" />
    <rect
      x="8.5"
      y="7.5"
      width="484"
      height="484"
      rx="25.5"
      fill="white"
      stroke="#6B00DF"
      strokeWidth="15"
    />
    <rect
      x="39"
      y="28"
      width="428"
      height="189"
      fill="white"
      stroke="#6B00DF"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="20 20"
    />
    <rect
      x="39"
      y="218"
      width="428"
      height="252"
      fill="white"
      stroke="#6B00DF"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="20 20"
    />
    <rect x="68" y="400" width="185" height="47" rx="20" fill="#6B00DF" />
    <path
      d="M219.287 136.35V164.665H103.779V148.731L117.98 133.988C118.989 132.942 120.593 132.942 121.601 133.988L136.328 149.276L137.68 150.68L139.033 149.276L183.576 103.038C184.584 101.992 186.188 101.992 187.196 103.038L219.287 136.35ZM84.0115 57H239.055C247.832 57 255.066 64.4064 255.066 73.6921V185.114C255.066 194.399 247.832 201.805 239.055 201.805H84.0115C75.2339 201.805 68 194.399 68 185.114V73.6921C68 64.4064 75.2339 57 84.0115 57ZM86.2477 186.992H236.818C237.933 186.992 238.987 186.532 239.753 185.736C240.516 184.945 240.933 183.883 240.933 182.792V76.0134C240.933 74.9218 240.516 73.8614 239.753 73.069C238.987 72.2742 237.933 71.814 236.818 71.814H86.2477C85.1334 71.814 84.0796 72.2742 83.3139 73.069C82.5504 73.8614 82.1334 74.9218 82.1334 76.0134V182.792C82.1334 183.883 82.5504 184.945 83.3139 185.736C84.0796 186.532 85.1334 186.992 86.2477 186.992ZM100.798 104.643C100.798 97.0664 106.697 91.0454 113.828 91.0454C120.958 91.0454 126.857 97.0664 126.857 104.643C126.857 112.218 120.958 118.239 113.828 118.239C106.697 118.239 100.798 112.218 100.798 104.643Z"
      fill="#7A00FF"
    />
    <rect
      x="68"
      y="237.848"
      width="364.355"
      height="20"
      rx="10"
      fill="#6B00DF"
    />
    <rect
      x="68"
      y="278.227"
      width="244.155"
      height="20"
      rx="10"
      fill="#6B00DF"
    />
    <rect
      x="68"
      y="323.875"
      width="364.355"
      height="15"
      rx="7.5"
      fill="#6B00DF"
    />
    <rect
      x="68"
      y="352.986"
      width="329.609"
      height="15"
      rx="7.5"
      fill="#6B00DF"
    />
  </svg>
);
export { cardIcon, defaultVariantIcon, cardWithWrappersVariantIcon };
